import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaPlus, FaCheck, FaSpinner, FaClipboardCheck } from 'react-icons/fa';
import style from '../css/BottomTab.module.css';
import { FaRightToBracket } from 'react-icons/fa6';

const BottomTab = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const tabs = [
		{ name: 'New', path: '/new-booking', icon: <FaPlus /> },
		{ name: 'Accepted', path: '/accepted', icon: <FaCheck /> },
		{ name: 'Progress', path: '/progress', icon: <FaSpinner /> },
		{ name: 'Completed', path: '/completed', icon: <FaClipboardCheck /> },
		{ name: 'LogOut', path: '/', icon: <FaRightToBracket color='red'/> },
	];

	return (
		<div className={style.bottomTab}>
			{tabs.map((tab) => (
				<button
					key={tab.name}
					className={`${style.tabItem} ${
						location.pathname === tab.path ? style.active : ''
					}`}
					onClick={() => navigate(tab.path)}
				>
					{tab.icon} <span>{tab.name}</span>
				</button>
			))}
		</div>
	);
};

export default BottomTab;
